// extracted by mini-css-extract-plugin
export default {"share":"index_share_Lahqx"};